import type React from 'react';

import type { Company } from '../../../../../../domain/company';
import type { AdNetworkSignal as AdNetworkSignalType, SignalType } from '../../../../../../domain/signal';
import { SignalHeader } from '../../SignalHeader';
import { StyledSignalItem, StyledSignalTitleContainer } from '../../styles';
import { HighlightedText } from '../HighlightedText/HighlightedText';

type Props = {
  signal: AdNetworkSignalType;
  company: Company;
};

export const AdNetworkSignal: React.FC<Props> = ({ signal, company }) => {
  const title = `${company.name ?? company.domain} ${
    signal.changeType === 'StartedWorkingWith' ? 'started to work with' : 'stopped working with'
  }`;
  const getAdNetworksText = () => {
    if (signal.adNetworkNames.length === 1) {
      return '1 ad-network';
    }

    return `${signal.adNetworkNames.length} ad-networks`;
  };

  const getTooltipContent = () => {
    return signal.adNetworkNames.map((name) => <div key={name}>{name}</div>);
  };

  return (
    <StyledSignalItem>
      <SignalHeader type={signal.type as SignalType} eventHappenedDaysAgo={signal.eventHappenedDaysAgo} />
      <StyledSignalTitleContainer>
        {title}{' '}
        <HighlightedText text={getAdNetworksText()} tooltipContent={getTooltipContent()} minWidth={50} maxWidth={180} />
      </StyledSignalTitleContainer>
    </StyledSignalItem>
  );
};
